/**
 * Web StorageAdapter — thin wrapper around the Dexie IStorage impl from
 * `@shopista/storage/web`.
 *
 * CP2: apps/web is the ONLY place that imports the concrete Dexie impl
 * (apart from packages/storage/web itself). Orchestrators consume the
 * returned value typed as `StorageAdapter` (alias for IStorage) and never
 * see a Dexie symbol.
 */

import type { StorageAdapter } from '@shopista/shared/stores';
import { createDexieStorage } from '@shopista/storage/web';

export function createWebStorageAdapter(): StorageAdapter {
  return createDexieStorage();
}
